import React from 'react'

const IconOne: React.FC = () => {
  return (
    <svg
      width="26"
      height="18"
      viewBox="0 0 29 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.4288 3.12578C27.1096 1.8972 26.1598 0.927706 24.9563 0.601755C22.7622 0 14.0101 0 14.0101 0C14.0101 0 5.24991 0 3.06394 0.593397C1.86043 0.927706 0.910725 1.8972 0.58324 3.12578C0.00195312 5.35729 0.00195312 10.0042 0.00195312 10.0042C0.00195312 10.0042 0.00195312 14.6594 0.58324 16.8826C0.902538 18.1112 1.85225 19.0807 3.05575 19.4066C5.24172 20 14.002 20 14.002 20C14.002 20 22.7622 20 24.9481 19.4066C26.1517 19.0807 27.1014 18.1112 27.4207 16.8826C28.0019 14.6511 28.0019 10.0042 28.0019 10.0042C28.0019 10.0042 28.0101 5.35729 27.4288 3.12578ZM11.202 14.3V5.71667L18.4803 10.0042L11.202 14.3Z"
        fill="#FF0000"
      />
    </svg>
  )
}

export default IconOne
